import React, { useEffect } from 'react';
import { useLanguage } from '../../contexts/languageContext';
import { useTheme } from '../../contexts/themeContext';
import { trackEvent } from '../../lib/analytics';
import CVChat, { personaForTheme } from './CVChat';
import './CVChat.scss';

/**
 * Pagina dedicata alla chat, servita su /talktome.
 *
 * Il ritorno al CV non sta qui ma nella barra di navigazione, che su questa
 * rotta sostituisce il fumetto e la stampa con quel comando: un secondo pulsante
 * "torna indietro" dentro la pagina sarebbe una duplicazione, e la barra e' il
 * posto dove l'utente cerca la navigazione.
 */
const TalkToMePage: React.FC = () => {
  const { t } = useLanguage();
  const { theme } = useTheme();
  const persona = personaForTheme(theme);

  useEffect(() => {
    try {
      trackEvent('talktome_open', { persona });
    } catch {
      // l'analytics non deve mai rompere la pagina
    }
  }, [persona]);

  return (
    <main className="cv-chat-page no-print">
      <div className="cv-chat-page__inner">
        <header className="cv-chat-page__header">
          <h1 className="cv-chat-page__title">{t('talkToMe')}</h1>
          <p className="cv-chat-page__lead">{t('chatPageLead')}</p>
          <p className="cv-chat-page__persona">
            {persona === 'formal' ? t('chatSubtitleFormal') : t('chatSubtitleInformal')}
          </p>
          <p className="cv-chat-page__compliance">{t('chatAiActNotice')}</p>
        </header>

        <CVChat active showHeader={false} className="cv-chat__conversation--page" />
      </div>
    </main>
  );
};

export default TalkToMePage;
